export default (state) => Object.values(state.importers.data)
